// import PropTypes from "prop-types"
// ... (unchanged commented-out block above, left as-is)

// -------------------------------------
import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import {
  CardBody,
  Card,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
} from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import classnames from "classnames"
import { isMobile } from "react-device-detect"

import LoginLapImag from "../../assets/images/Login PC.png"
import LoginMobImag from "../../assets/images/Login PC.png"

import { loginUser, apiError, socialLogin } from "../../store/actions"
import { color } from "echarts/lib/export"

const Login = props => {
  const [modalState, setModalState] = useState(false)
  const [activeTab, setActiveTab] = useState("Individual")
  const [activeTabContent, setActiveTabContent] = useState("1")
  const [showPassword, setShowPassword] = useState(false)
  const [alertVisible, setAlertVisible] = useState(true)
  const [messageToken, setMessageToken] = useState("")
  const [helprc, onhelpOpenRC] = useState(false)
  const [toggleMessage, setToggleMessage] = useState("")
  var tawklink = ""

  useEffect(() => {
    const loader = document.querySelector(".loader")
    loader.classList.add("loader--hide")

    setMessageToken(localStorage.getItem("notificationToken"))
  }, [])
  const toggle1 = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }
  const Alldata = JSON.parse(localStorage.getItem("dataJ"))

  const toggleModal = () => setModalState(!modalState)
  const togglePasswordVisibility = () => setShowPassword(!showPassword)
  const hideAlert = () => setAlertVisible(false)
  const handleValidSubmit = (event, values) => {
    props.loginUser(values, props.history)
  }
  const handleTabToggle = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const handleToggleMessage = event => setToggleMessage(event.target.value)

  const renderAlert = () => {
    if (!props.error || typeof props.error !== "string") return null

    const isSuccess =
      props.error.includes("already registered") ||
      props.error === "Somethiing went wrong, Please try again!"

    return (
      <Modal
        isOpen={alertVisible}
        toggle={hideAlert}
        centered
        contentClassName="advocacy-alert-content"
      >
        <div
          style={{
            // background: "linear-gradient(160deg, #f6e2c2 0%, #c98f4f 100%)",
            borderRadius: "16px",
            padding: "44px 24px 0px",
            // fontFamily: "Georgia, 'Times New Roman', serif",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "16px",
              borderBottom: "1px solid rgba(255,255,255,0.35)",
              paddingBottom: "12px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ color: "#1d1d1f", fontWeight: 600, fontSize: "1.05rem" }}>
                {isSuccess ? "Success" : ""}
              </span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22zm7-6v-5a7 7 0 0 0-5.5-6.84V3a1.5 1.5 0 0 0-3 0v1.16A7 7 0 0 0 5 11v5l-1.7 1.7a1 1 0 0 0 .7 1.7h16a1 1 0 0 0 .7-1.7L19 16z"
                  fill="#1d1d1f"
                />
              </svg>
            </div>
            <button
              onClick={hideAlert}
              style={{
                background: "#1d1d1f",
                border: "none",
                color: "#fff",
                width: "26px",
                height: "26px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                fontSize: "1rem",
                lineHeight: 1,
              }}
            >
              &times;
            </button>
          </div> */}

          <div style={{ textAlign: "center", padding: "8px 4px 4px" }}>
            <p
              style={{
                color: "#fff",
                fontSize: "1rem",
                lineHeight: 1.5,
                textShadow: "0 1px 4px rgba(0,0,0,0.25)",
                margin: "0 0 20px",
              }}
            >
              {props.error}
            </p>

            <button
              onClick={hideAlert}
              style={{
                background: "#1d1d1f",
                color: "#fff",
                border: "none",
                borderRadius: "10px",
                padding: "10px 28px",
                fontSize: "0.9rem",
                fontWeight: 500,
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              }}
            >
              OK
            </button>
          </div>
        </div>
      </Modal>
    )
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>The Advocacy Live Stream</title>
      </MetaTags>
      <Modal
        size="xl"
        isOpen={modalState}
        toggle={toggleModal}
        centered
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Photo Mosaic</h5>
          <button
            type="button"
            onClick={toggleModal}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <iframe
            allow="camera; microphone"
            title="test"
            className="embed-responsive-item mosaic"
            src={encodeURI("https://demo-mosaic.herokuapp.com/")}
          />
        </div>
      </Modal>
      <Modal
        isOpen={helprc}
        toggle={() => {
          onhelpOpenRC(!helprc)
        }}
        centered={true}
        style={{ width: "auto" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Help Desk</h5>
          <button
            type="button"
            onClick={() => {
              onhelpOpenRC(!helprc)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {Alldata.data.lobby.data.areas.map((item, i) =>
            (() => {
              switch (item.id) {
                case "help": {
                  ;<div>
                    {item.url ? (tawklink = item.url) : (tawklink = "")}
                  </div>
                }
              }
            })()
          )}
          <iframe
            height="450px"
            width="100%"
            title="test"
            className="embed-responsive-item"
            src={encodeURI(tawklink)}
          />
        </div>
      </Modal>
      <Container fluid style={{ padding: 0, position: "relative", overflow: "hidden" }}>
        <img
          loading="lazy"
          src={
            isMobile
              ? "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FLogin%20Phone.jpg?alt=media&token=21f51adc-b57f-4239-831d-27030056791a"
              : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Apple%20Virtual%20Platform%202026%2FLogin%20Laptop.jpg?alt=media&token=2d7167e7-5627-4648-8187-d723339c67e6"
          }
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            objectFit: "cover",
            zIndex: 0,
          }}
          alt="Login"
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-end",
            padding: "40px 20px 60px",
            boxSizing: "border-box",
          }}
        >
          <h1
            style={{
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontWeight: 500,
              fontSize: "1.9rem",
              color: "#1d1d1f",
              textShadow: "0 2px 8px rgba(255,255,255,0.6)",
              margin: "0 0 8px",
              textAlign: "center",
            }}
          >
            Welcome
          </h1>

          <p
            style={{
              color: "#fff",
              fontSize: "0.9rem",
              lineHeight: 1.4,
              textAlign: "center",
              textShadow: "0 2px 6px rgba(0,0,0,0.6)",
              margin: "0 0 20px",
              maxWidth: "420px",
            }}
          >
            50 Years. One Mindset. Think Different.
            <br />
            Log in. Your Experience Awaits.
          </p>

          <div style={{ width: "100%", maxWidth: "340px" }}>
            {renderAlert()}

            <AvForm className="form-horizontal" onValidSubmit={handleValidSubmit}>
              <div style={{ position: "relative", marginBottom: "12px" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    pointerEvents: "none",
                    opacity: 1,
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 12c2.7 0 4.9-2.2 4.9-4.9S14.7 2.2 12 2.2 7.1 4.4 7.1 7.1 9.3 12 12 12zm0 2.4c-3.3 0-9.8 1.6-9.8 4.9v2.5h19.6v-2.5c0-3.3-6.5-4.9-9.8-4.9z"
                      fill="#000"
                    />
                  </svg>
                </span>
                <AvField
                  name="Firstname"
                  placeholder="Enter your Name"
                  type="text"
                  required
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "11px 14px 11px 38px",
                    borderRadius: "10px",
                    border: "none",
                    background: "rgba(240, 240, 242, 0.94)",
                    color: "#1d1d1f",
                    fontSize: "0.82rem",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    outline: "none",
                  }}
                />
              </div>

              <div style={{ position: "relative", marginBottom: "14px" }}>
                <span
                  style={{
                    position: "absolute",
                    left: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 2,
                    pointerEvents: "none",
                    opacity: 1,
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M2 5.5A2.5 2.5 0 0 1 4.5 3h15A2.5 2.5 0 0 1 22 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-15A2.5 2.5 0 0 1 2 18.5v-13zm2 .2 8 5.7 8-5.7V5.5a.5.5 0 0 0-.5-.5h-15a.5.5 0 0 0-.5.5v.2z"
                      fill="#000"
                    />
                  </svg>
                </span>
                <AvField
                  name="Email"
                  placeholder="Enter your E-mail ID"
                  type="email"
                  required
                  style={{
                    width: "100%",
                    boxSizing: "border-box",
                    padding: "11px 14px 11px 38px",
                    borderRadius: "10px",
                    border: "none",
                    background: "rgba(240, 240, 242, 0.94)",
                    color: "#1d1d1f !important",
                    fontSize: "0.82rem",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    outline: "none",
                  }}
                />
              </div>

              <AvField
                name="customaction"
                value="Login"
                type="text"
                required
                disabled
                hidden
                style={{ display: "none" }}
              />

              <button
                type="submit"
                style={{
                  width: "100%",
                  padding: "11px 16px",
                  border: "none",
                  borderRadius: "10px",
                  background: "#1d1d1f",
                  color: "#fff",
                  fontSize: "0.85rem",
                  fontWeight: 500,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
                }}
              >
                Log-In
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12h14M13 6l6 6-6 6"
                    stroke="#fff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </AvForm>

            {/* <p
              style={{
                marginTop: "12px",
                textAlign: "center",
                color: "#2c2c2e",
                fontSize: "0.75rem",
                textShadow: "0 2px 6px rgba(255,255,255,0.6)",
              }}
            >
              Please login using your SEED email ID
            </p> */}
          </div>
        </div>
      </Container>
      {/* <div
        style={{
          cursor: "pointer",
          height: "80px",
          width: "80px",
          position: "absolute",
          top: "85%",
          right: "10%",
        }}
      >
        <img width="100px" src="https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/apple%20virtual%20platform%2FHELP%20Button.png?alt=media" onClick={()=>{onhelpOpenRC(!helprc)}} />
        
      </div> */}
    </React.Fragment>
  )
}

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
}

const mapStateToProps = state => {
  const { error } = state.Login
  return { error }
}

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
)